/*
  Bundle upsell widget + "complete your set" popup.
  Works with the theme's AJAX cart: dispatches/listens to 'ajaxProduct:added'
  so the cart drawer rebuilds and opens after bundle adds.
*/
(function() {
  'use strict';

  function formatMoney(cents, moneyFormat) {
    try {
      if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
        return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      }
    } catch (e) { /* fall through */ }
    var amount = (cents / 100).toFixed(2);
    return (moneyFormat || '{{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    }).then(function(res) {
      return res.json().then(function(json) {
        if (!res.ok) { throw json; }
        return json;
      });
    });
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function(res) {
      return res.json();
    });
  }

  function notifyCartUpdated(addedItem) {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: { product: addedItem },
      bubbles: true
    }));
  }

  function BundleUpsell(widget) {
    var dataEl = document.querySelector('[data-bundle-upsell-data]');
    if (!dataEl) { return; }

    try {
      this.data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    this.widget = widget;
    this.popup = document.querySelector('[data-bundle-popup]');
    this.dismissKey = 'bundleUpsell:dismissed:' + this.data.bundleHandle;
    this.suppressPopup = false;

    this.initWidget();
    this.initPopup();
  }

  BundleUpsell.prototype = {
    /* ── Widget ─────────────────────────────────────────── */

    initWidget: function() {
      var self = this;
      this.checks = Array.prototype.slice.call(this.widget.querySelectorAll('[data-bundle-check]'));
      this.atcBtn = this.widget.querySelector('[data-bundle-atc]');
      this.atcText = this.widget.querySelector('[data-bundle-atc-text]');
      this.errorEl = this.widget.querySelector('[data-bundle-error]');

      this.checks.forEach(function(check) {
        check.addEventListener('change', self.updateWidgetTotal.bind(self));
      });
      this.atcBtn.addEventListener('click', this.onWidgetAdd.bind(this));
      this.updateWidgetTotal();
    },

    checkedItems: function(checks) {
      return checks.filter(function(c) { return c.checked; }).map(function(c) {
        return {
          id: parseInt(c.dataset.variantId, 10),
          productId: parseInt(c.dataset.productId, 10),
          price: parseInt(c.dataset.price, 10)
        };
      });
    },

    updateWidgetTotal: function() {
      var selected = this.checkedItems(this.checks);
      var total = selected.reduce(function(sum, item) { return sum + item.price; }, 0);

      this.atcBtn.disabled = selected.length === 0;
      this.atcText.innerHTML = selected.length === 0
        ? this.data.addToCartText
        : this.data.addToCartText + ' – ' + formatMoney(total, this.data.moneyFormat);
    },

    onWidgetAdd: function() {
      var self = this;
      var selected = this.checkedItems(this.checks);
      if (!selected.length || this.atcBtn.classList.contains('btn--loading')) { return; }

      this.atcBtn.classList.add('btn--loading');
      this.showError(this.errorEl, null);

      addItems(selected.map(function(item) { return { id: item.id, quantity: 1 }; }))
        .then(function(res) {
          self.suppressPopup = true;
          notifyCartUpdated(res.items ? res.items[0] : res);
        })
        .catch(function(err) {
          self.showError(self.errorEl, err);
        })
        .finally(function() {
          self.atcBtn.classList.remove('btn--loading');
        });
    },

    showError: function(el, err) {
      if (!el) { return; }
      if (!err) {
        el.hidden = true;
        return;
      }
      el.textContent = (err && err.description) || 'Something went wrong. Please try again.';
      el.hidden = false;
    },

    /* ── Popup ──────────────────────────────────────────── */

    initPopup: function() {
      var self = this;

      document.addEventListener('ajaxProduct:added', function(evt) {
        self.onProductAdded(evt);
      });

      if (!this.popup) { return; }

      this.popupChecks = Array.prototype.slice.call(this.popup.querySelectorAll('[data-popup-check]'));
      this.popupRows = Array.prototype.slice.call(this.popup.querySelectorAll('[data-popup-item]'));
      this.popupAtc = this.popup.querySelector('[data-bundle-popup-atc]');
      this.popupAtcText = this.popup.querySelector('[data-popup-atc-text]');
      this.popupTotal = this.popup.querySelector('[data-popup-total]');
      this.popupCompare = this.popup.querySelector('[data-popup-compare]');
      this.popupError = this.popup.querySelector('[data-popup-error]');

      this.popupChecks.forEach(function(check) {
        check.addEventListener('change', self.updatePopupTotal.bind(self));
      });
      this.popupAtc.addEventListener('click', this.onPopupAdd.bind(this));
      this.popup.querySelector('[data-bundle-popup-decline]').addEventListener('click', function() {
        self.closePopup(true);
      });
      this.popup.querySelector('[data-bundle-popup-close]').addEventListener('click', function() {
        self.closePopup(true);
      });
      document.addEventListener('keydown', function(evt) {
        if (evt.key === 'Escape' && !self.popup.hidden) { self.closePopup(true); }
      });
    },

    onProductAdded: function(evt) {
      if (this.suppressPopup) {
        this.suppressPopup = false;
        return;
      }
      if (!this.popup || !this.popup.hidden) { return; }
      if (sessionStorage.getItem(this.dismissKey)) { return; }

      var added = evt.detail && evt.detail.product;
      var addedId = added && (added.product_id || (added.items && added.items[0] && added.items[0].product_id));
      if (addedId !== this.data.currentProductId) { return; }

      var self = this;
      getCart().then(function(cart) {
        var inCart = {};
        cart.items.forEach(function(item) { inCart[item.product_id] = true; });

        var missing = self.data.items.filter(function(item) {
          return !inCart[item.productId];
        });
        if (!missing.length) { return; }

        self.openPopup(inCart);
      });
    },

    openPopup: function(inCart) {
      var self = this;

      this.popupRows.forEach(function(row) {
        var productId = parseInt(row.dataset.productId, 10);
        var isInCart = !!inCart[productId];
        row.classList.toggle('is-in-cart', isInCart);
        row.querySelector('[data-popup-in-cart]').hidden = !isInCart;

        var check = row.querySelector('[data-popup-check]');
        check.checked = !isInCart;
        check.disabled = isInCart;
        check.closest('label').querySelector('.bundle-upsell__check-ui').hidden = isInCart;
      });

      this.updatePopupTotal();
      this.showError(this.popupError, null);

      setTimeout(function() {
        self.popup.hidden = false;
        document.documentElement.classList.add('bundle-popup-open');
      }, 500);
    },

    closePopup: function(dismissed) {
      this.popup.hidden = true;
      document.documentElement.classList.remove('bundle-popup-open');
      if (dismissed) {
        try { sessionStorage.setItem(this.dismissKey, '1'); } catch (e) { /* private mode */ }
      }
    },

    popupSelection: function() {
      return this.popupChecks.filter(function(c) { return c.checked && !c.disabled; });
    },

    updatePopupTotal: function() {
      var inCartTotal = 0;
      var inCartCount = 0;
      this.popupChecks.forEach(function(c) {
        if (c.disabled) {
          inCartTotal += parseInt(c.dataset.price, 10);
          inCartCount++;
        }
      });

      var selection = this.popupSelection();
      var selectedTotal = selection.reduce(function(sum, c) {
        return sum + parseInt(c.dataset.price, 10);
      }, 0);

      var covered = inCartCount + selection.length;
      var fullSet = covered === this.data.items.length;
      var total = inCartTotal + selectedTotal;

      if (fullSet) {
        var discounted = Math.round(total * (100 - this.data.discountPercentage) / 100);
        this.popupCompare.innerHTML = formatMoney(total, this.data.moneyFormat);
        this.popupCompare.hidden = false;
        this.popupTotal.innerHTML = formatMoney(discounted, this.data.moneyFormat);
        this.popupAtcText.textContent = this.data.addBundleText;
      } else {
        this.popupCompare.hidden = true;
        this.popupTotal.innerHTML = formatMoney(total, this.data.moneyFormat);
        this.popupAtcText.textContent = this.data.addSelectedText;
      }

      this.popupAtc.disabled = selection.length === 0;
    },

    onPopupAdd: function() {
      var self = this;
      var selection = this.popupSelection();
      if (!selection.length || this.popupAtc.classList.contains('btn--loading')) { return; }

      this.popupAtc.classList.add('btn--loading');
      this.showError(this.popupError, null);

      addItems(selection.map(function(c) {
        return { id: parseInt(c.dataset.variantId, 10), quantity: 1 };
      }))
        .then(function(res) {
          self.suppressPopup = true;
          self.closePopup(false);
          notifyCartUpdated(res.items ? res.items[0] : res);
        })
        .catch(function(err) {
          self.showError(self.popupError, err);
        })
        .finally(function() {
          self.popupAtc.classList.remove('btn--loading');
        });
    }
  };

  function init() {
    var widget = document.querySelector('[data-bundle-upsell]');
    if (widget && !widget.dataset.bundleInitialized) {
      widget.dataset.bundleInitialized = 'true';
      new BundleUpsell(widget);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
